import React, { useState } from 'react'


import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import TextField from '@material-ui/core/TextField'
import TabPanel from '../TabPanel/TabPanel'

import Options from '../Options/Options'
import Ingredients from '../Ingredients/Ingredients'

import AppBar from '@material-ui/core/AppBar'

export default function ModifyItemPanels({ item, addOptions, addIngredients, setNotes, notes }) {

    const [value, setValue] = useState(0)

    const addOptionsToTabPanel = () => {

        let options = [];

        if (item.length !== 0) {
            item.Option_List.map((option) =>
                options.push(
                    <Options
                        key={option}
                        uid={option}
                        addOptions={addOptions}
                        checkedItems={item.subOptions}
                    />
                )
            )
        }
        return options;
    }

    const addIngredientsToTabPanel = () => {

        let ingredients = [];

        if (item.length !== 0) {
            item.Ingredient_List.map((ingredient) =>
                ingredients.push(
                    <Ingredients
                        key={ingredient}
                        uid={ingredient}
                        addIngredients={addIngredients}
                    />
                )
            )
        }
        return ingredients;
    }

    const addNotesToTabPanel = () => {

        const styles = { width: "100%" }

        return (
            <TextField
                id="outlined-multiline-static"
                value={notes}
                label="Notes"
                style={styles}
                onChange={event => {
                    const { value } = event.target;
                    setNotes(value)
                }}
                multiline
                rows="12"
                placeholder="Notes about the item..."
                variant="outlined"
            />
        )
    }

    const addTabPanels = () => {

        let counter = 0;
        let tabPanels = [];

        if (item.Option_List.length !== 0) {
            tabPanels.push(
                <TabPanel
                    key={counter}
                    value={value}
                    index={counter} >
                    {addOptionsToTabPanel()}
                </TabPanel>
            )
            counter++;
        }

        if (item.Ingredient_List.length !== 0) {
            tabPanels.push(
                <TabPanel
                    key={counter}
                    value={value}
                    index={counter} >
                    {addIngredientsToTabPanel()}
                </TabPanel>
            )
            counter++;
        }

        tabPanels.push(
            <TabPanel
                key={counter}
                value={value}
                index={counter} >
                {addNotesToTabPanel()}
            </TabPanel>
        )

        return tabPanels;
    }

    return (
        <div>
            <AppBar position="sticky" color="default">
                <Tabs
                    value={value}
                    onChange={(event, value) => {
                        setValue(value)
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    scrollButtons="on"
                >
                    {item.Option_List.length !== 0 && <Tab label="Options" />}
                    {item.Ingredient_List.length !== 0 && <Tab label="Ingredients" />}
                    <Tab label="Extra Notes" />
                </Tabs>
            </AppBar>
            {addTabPanels()}
        </div>
    )

}
